import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
export const GalleryCardFooter = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "flex grow items-end",
        children: /*#__PURE__*/ _jsx("div", {
            className: "flex grow",
            children: /*#__PURE__*/ _jsx("div", {
                className: "mx-3 mb-3.5",
                children: children
            })
        })
    });
});
GalleryCardFooter.displayName = "GalleryCardFooter";
